import { render, staticRenderFns } from "./BaseBookmark.vue?vue&type=template&id=6f06fd32&scoped=true&lang=pug&"
import script from "./BaseBookmark.vue?vue&type=script&lang=js&"
export * from "./BaseBookmark.vue?vue&type=script&lang=js&"
import style0 from "./BaseBookmark.vue?vue&type=style&index=0&id=6f06fd32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f06fd32",
  null
  
)

export default component.exports